import React from "react";
import styles from "./Copyright.module.css";
const Copyright = () => {
  return (
    <p className={styles.copyright}>
      Copyright © 2026 WENIV All Rights Reserved
    </p>
  );
};

export default Copyright;
